import { API_GET_DEEP_LINK_COUPANG } from "core/api";
import API from "core/networks/API";
import { useState } from "react";

export const useDeepLinkCoupon = (cb: any) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleFetchDeepLinkCoupon = async (data: any) => {
    setLoading(true);
    try {
      const res = await API.post(API_GET_DEEP_LINK_COUPANG, data);
      cb.onSuccess(res.data?.data || []);
      setLoading(false);
    } catch (error: any) {
      cb.onError(error);
      setLoading(false);
    }
    
  };

  return { loading, handleFetchDeepLinkCoupon };
  
}